.fp-card(style='background: #fff')
  QrCodeVue.fp-image.-fluid.-contain(:value='auctionMarketplaceLink' level='L' render-as='svg' background='#fff' foreground='#000')
